var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartnerChain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 27.5 18.75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1171275120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 18.75,
    rx: 3,
    fill: "var(--fill-0, #EFEFEF)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5 9.375C15.5 11.7912 13.5412 13.75 11.125 13.75H9.375C6.95876 13.75 5 11.7912 5 9.375C5 6.95876 6.95876 5 9.375 5H9.8125M12 9.375C12 6.95876 13.9588 5 16.375 5H18.125C20.5412 5 22.5 6.95876 22.5 9.375C22.5 11.7912 20.5412 13.75 18.125 13.75H17.6875",
    stroke: "var(--stroke-0, #1B1B1B)",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerChain);
export default __webpack_public_path__ + "static/media/PartnerChain.49af671f0c672cc1edc1cc7a0784e37f.svg";
export { ForwardRef as ReactComponent };